<div class="wrapper__headerComponent container my-5">
    <div class="container-example-linea-avance-govco mx-0 my-5">
        <!-- Inicio linea avance -->
        <div class="linea-avance-govco ih-linea-avance-govco m-0 p-0" id="lineaAvance3"
        *ngIf="datosEtapas.length > 0">
            <div class="mb-4">
                <div class="progress w-100">
                    <progress class="progress-bar w-100" [value]="progreso" max="100"></progress>
                </div>
                <div class="items-header-linea-avance-govco">
                    <div class="header-linea-avance-govco" 
                        *ngFor="let etapa of datosEtapas; let i = index"
                        [ngClass]="{ 'active-linea-avance-govco': i === etapaActiva }">
                        <button 
                            class="indicator-linea-avance-govco" type="button"
                            [attr.data-la-target]="'#itemlineaAvance' + etapa.Id"
                            [attr.percentage]="(100 / datosEtapas.length) * (i + 1)"
                            onClick="clickHorizontalAdvanceLine(event)" 
                            (click)="clickHorizontalAdvanceLine(i)"
                            arial-label="Seleccionar etapa">
                            <span>{{ etapa.Orden }}</span>
                        </button>
                        <span 
                            class="title-linea-avance-govco">
                            {{ etapa.Etapa }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <!-- Fin Linea avance -->
         <div class="d-flex flex-wrap justify-content-end gap-2 mb-5">
            <button id="btn-agregar"
                    class="btn-govco outline-btn-govco hvr-shrink"
                    (click)="acciones($event)"
                    *ngIf="onlyView && datosEtapas.length < 8"
                    aria-label="Acciones">
                {{"gestion-tablero-resumen.btn-agregar" | translate}}
            </button>
            <button id="btn-agregar"
                    class="btn-govco outline-btn-govco hvr-shrink"
                    (click)="goBack()"
                    aria-label="Volver"
                    *ngIf="!onlyView"
                    [disabled]="datosEtapas.length < 5 ">
                {{"volver" | translate}}
            </button>
        </div>
        <div class="contenedor-tabla w-100">
            <app-table
                *ngIf="onlyView"
                [estiloEncabezado]="'height: auto !important;'"
                id="tblDemandante"
                [acciones]="actions"
                (eventoAccion)="acciones($event)"
                [datos]="datosEtapas"
                [columnas]="columnasEtapas"
                [paginacion]="false">
            </app-table>

                <div 
                    class="d-flex justify-content-center align-items-center">
                    <div class="w-75" *ngIf="!onlyView">
                        <app-form
                        [title]="getFlag() === 'editar' ? tableroText['editar-etapa'] : tableroText['agregar-etapa']"
                        [fields]="etapaFormFields"
                        (changeAction)="onSubmitForm($event)"
                        [withSubmitButton]="true"
                        [sumbitButtonText]="'gestion-tablero-resumen.btn-guardar' | translate"
                        (submitAction)="confirmarCambios($event, getFlag())">
                        </app-form>
                        <div class="d-flex flex-wrap justify-content-end gap-2 mb-5"
                        *ngIf="datosEtapas.length > 4 && getFlag() === 'agregar'">
                            <button id="btn-agregar"
                                    class="btn-govco outline-btn-govco hvr-shrink"
                                    (click)="guardarProcesos()"
                                    aria-label="Guardar cambios">
                                {{"gestion-tablero-resumen.guardar-cambios" | translate}}
                            </button>
                        </div>
                    </div>
                </div>
        </div>
    </div>
</div>